module.exports = __webpack_public_path__ + "static/img/decidoc-thumb.8b449d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-thumb.jpg
// module id = 31
// module chunks = 0